enum CheckoutButtonMethodType {
    AMAZON_PAY_V2 = 'amazonpay',
    BRAINTREE_PAYPAL = 'braintreepaypal',
    BRAINTREE_PAYPAL_CREDIT = 'braintreepaypalcredit',
    GOOGLEPAY_ADYENV2 = 'googlepayadyenv2',
    GOOGLEPAY_AUTHORIZENET = 'googlepayauthorizenet',
    GOOGLEPAY_BRAINTREE = 'googlepaybraintree',
    GOOGLEPAY_CHECKOUTCOM = 'googlepaycheckoutcom',
    GOOGLEPAY_CYBERSOURCEV2 = 'googlepaycybersourcev2',
    GOOGLEPAY_STRIPE = 'googlepaystripe',
    MASTERPASS = 'masterpass',
    PAYPALEXPRESS = 'paypalexpress',
    PAYPALCOMMERCE = 'paypalcommerce',
}

export default CheckoutButtonMethodType;
